import { render, staticRenderFns } from "./deleteFeeDiscount.vue?vue&type=template&id=22be3240"
import script from "./deleteFeeDiscount.vue?vue&type=script&lang=js"
export * from "./deleteFeeDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports